<template>
    <section id="grades" class="welcome-grade-picker" dir="rtl">
        <div class="welcome-grade-picker__bg" aria-hidden="true">
            <span class="welcome-grade-picker__bg-code welcome-grade-picker__bg-code--1">{ }</span>
            <span class="welcome-grade-picker__bg-code welcome-grade-picker__bg-code--2">0101</span>
            <span class="welcome-grade-picker__bg-code welcome-grade-picker__bg-code--3">AI</span>
        </div>

        <header class="welcome-grade-picker__header">
            <h2 class="welcome-grade-picker__title">اختار مرحلتك… وابدأ بالطريقة الصح</h2>
            <p class="welcome-grade-picker__subtitle">
                كل مرحلة ليها هدف مختلف. أولى ثانوي تبني الأساس وتجهزك للمستقبل، وتانية ثانوي تحتاج نظام واضح يساعدك تستهدف أعلى درجة بثقة.
            </p>
        </header>

        <div class="welcome-grade-picker__grid">
            <article
                v-for="card in cards"
                :key="card.slug"
                class="welcome-grade-card"
                :class="`welcome-grade-card--${card.theme}`"
            >
                <div class="welcome-grade-card__top">
                    <div>
                        <span class="welcome-grade-card__badge">{{ card.badge }}</span>
                        <h3 class="welcome-grade-card__title">{{ card.title }}</h3>
                    </div>
                </div>

                <h4 class="welcome-grade-card__headline">{{ card.headline }}</h4>
                <p class="welcome-grade-card__text">{{ card.text }}</p>

                <ul class="welcome-grade-card__points">
                    <li v-for="point in card.points" :key="point">{{ point }}</li>
                </ul>

                <router-link
                    :to="{ name: card.routeName }"
                    class="welcome-grade-card__cta welcome-grade-card__cta--block"
                >
                    <span>{{ card.cta }}</span>
                    <lucide-icon name="ArrowLeft" class="h-4 w-4" />
                </router-link>
            </article>
        </div>
    </section>
</template>

<script>
import LucideIcon from './LucideIcon.vue';
import { gradePickerCards } from './landing-grade-data';

export default {
    name: 'WelcomeGradePicker',
    components: { LucideIcon },
    data() {
        return {
            cards: gradePickerCards,
        };
    },
};
</script>
